import { newsAPI } from './api';
import {
  filterPublications,
  getStaticPublications,
  mergePublications,
} from './newsPublications';

export async function fetchPublications(categoryId = 'all') {
  const staticItems = filterPublications(getStaticPublications(), categoryId);
  const apiItems = await newsAPI.getPublications(
    categoryId === 'all' ? undefined : categoryId,
  );
  return mergePublications(staticItems, apiItems);
}

export async function fetchFeaturedPublications(limit = 6) {
  const staticAntologia = getStaticPublications().filter(
    (item) => item.category === 'antologia',
  );

  const [apiFeatured, apiAntologia] = await Promise.all([
    newsAPI.getPublications(undefined, { featuredOnly: true }),
    newsAPI.getPublications('antologia'),
  ]);

  const merged = mergePublications(
    staticAntologia,
    mergePublications(apiFeatured, apiAntologia),
  );

  return merged.slice(0, limit);
}
